var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-open"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0583 11.9167L17.725 16.0834C17.6 17.3584 17.5 18.3334 15.2416 18.3334H4.7583C2.49997 18.3334 2.39997 17.3584 2.27497 16.0834L1.94163 11.9167C1.87497 11.2251 2.09163 10.5834 2.4833 10.0917C2.49163 10.0834 2.49163 10.0834 2.49997 10.0751C2.9583 9.51675 3.64997 9.16675 4.42497 9.16675H15.575C16.35 9.16675 17.0333 9.51675 17.4833 10.0584C17.4916 10.0667 17.5 10.0751 17.5 10.0834C17.9083 10.5751 18.1333 11.2167 18.0583 11.9167Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.9165 9.52498V5.23332C2.9165 2.39998 3.62484 1.69165 6.45817 1.69165H7.5165C8.57484 1.69165 8.8165 2.00832 9.2165 2.54165L10.2748 3.95832C10.5415 4.30832 10.6998 4.52498 11.4082 4.52498H13.5332C16.3665 4.52498 17.0748 5.23332 17.0748 8.06665V9.55832",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.8584 14.1667H12.1417",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProjectsIcon);
export default __webpack_public_path__ + "static/media/My-Projects-icon.87dfa002b0d68276b9c59e1e3a4cb362.svg";
export { ForwardRef as ReactComponent };